/**
 * Maps journey-manifest music keys (e.g. "music-hill-home") to actual
 * audio file paths on disk. Until per-scene tracks are produced, region
 * prefixes map to the handful of available tracks so every painted scene
 * has music.
 *
 * Region keys are derived from the actual audio file (not the manifest
 * prefix) so adjacent scenes sharing the same track don't restart music.
 */

interface TrackDef {
  regionKey: string;
  urls: string[];
}

const TRACK_VERDANA_FIELDS: TrackDef = {
  regionKey: '_painted-music:verdana-fields',
  urls: ['assets/audio/music/verdana-fields.ogg', 'assets/audio/music/verdana-fields.m4a'],
};

const TRACK_AMBIENT_V3: TrackDef = {
  regionKey: '_painted-music:ambient-v3',
  urls: ['assets/audio/music/verdana-ambient-v3.mp3'],
};

const TRACK_AMBIENT_V4: TrackDef = {
  regionKey: '_painted-music:ambient-v4',
  urls: ['assets/audio/music/verdana-ambient-v4.mp3'],
};

const TRACK_PASTORAL: TrackDef = {
  regionKey: '_painted-music:pastoral',
  urls: ['assets/audio/music/lord-redstone-pastoral.ogg', 'assets/audio/music/lord-redstone-pastoral.m4a'],
};

const TRACK_DEPTHS: TrackDef = {
  regionKey: '_painted-music:depths',
  urls: ['assets/audio/music/lord-redstone-depths.ogg', 'assets/audio/music/lord-redstone-depths.m4a'],
};

const PREFIX_MAP: Record<string, TrackDef> = {
  hill:       TRACK_VERDANA_FIELDS,
  hearth:     TRACK_VERDANA_FIELDS,
  verdana:    TRACK_AMBIENT_V3,
  sablewind:  TRACK_PASTORAL,
  frostmere:  TRACK_AMBIENT_V4,
  ember:      TRACK_DEPTHS,
};

const FALLBACK = TRACK_VERDANA_FIELDS;

function trackFor(manifestMusicKey: string): TrackDef {
  const prefix = manifestMusicKey.replace(/^music-/, '').split('-')[0];
  return PREFIX_MAP[prefix] ?? FALLBACK;
}

export function resolveRegionKey(manifestMusicKey: string): string {
  return trackFor(manifestMusicKey).regionKey;
}

export function resolveMusicUrls(manifestMusicKey: string): string[] {
  return trackFor(manifestMusicKey).urls;
}
